import { jsx } from "react/jsx-runtime";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import { validateTidalLicense } from "../../base/index.js";
function AccessTimeFilled(props) {
  return /* @__PURE__ */ jsx(
    AccessTimeFilledIcon,
    {
      "data-testid": "AccessTimeFilled",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "AccessTimeFilled",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
AccessTimeFilled.tidalIconMeta = {
  categories: "map,location,time",
  name: "AccessTimeFilled"
};
validateTidalLicense();
export {
  AccessTimeFilled
};
//# sourceMappingURL=AccessTimeFilled.js.map
